// React hook wrapping Firebase Auth state.
//
// Subscribes to onAuthStateChanged once and shares the state via React
// context (mounted at the router root). Components use `useAuth()` to read
// the current user + a boolean loading state.

import { createContext, useContext } from 'react';
import type { User } from '../lib/auth';

export interface AuthContextValue {
  /** The current Firebase user, or null if unauthenticated. */
  user: User | null;
  /** True while the initial onAuthStateChanged hasn't resolved yet. */
  loading: boolean;
  /** True if `user` exists AND email is a workspace address. */
  isAuthorized: boolean;
}

export const AuthContext = createContext<AuthContextValue>({
  user: null,
  loading: true,
  isAuthorized: false,
});

export function useAuth(): AuthContextValue {
  return useContext(AuthContext);
}
